// Hardcoded fallback notices — used automatically when the database has no
// notice entries yet.

export const NOTICES_FALLBACK = [
  {
    id: 'crs-project-fellow-recruitment-2026',
    title: 'Recruitment: CRS Project Fellow (Junior) - I / II — Department of Basic Science and Humanities',
    description: `Applications are invited for ONE post of CRS Project Fellow (Junior) - I / II under the CRS project "Probing the Low-Lying and Isomeric Structure of 128Cs: Insights into the (pi)h11/2 Orbital in the A ~ 130 Region", sanctioned by UGC-DAE Consortium for Scientific Research, India.

Essential Qualifications:
- CRS Project Fellow (Junior) - I: M.Sc. (not earlier than 3 years) with a minimum of 55% marks in Physics.
- CRS Project Fellow (Junior) - II: M.Sc. (not earlier than 3 years) with a minimum of 55% marks in Physics, with valid JEST / GATE / NET-JRF / Lectureship / UGC-CSIR-NET JRF / Lectureship.

Fellowship Amount:
- CRS Project Fellow (Junior) - I: Rs. 14,000/month + HRA
- CRS Project Fellow (Junior) - II: Rs. 31,000/month + HRA

Duration of the Project: 1 year (extendible up to 3 years).

Interested eligible candidates are invited to apply by submitting their complete CV, a recent passport-size photograph, and scanned copies of all relevant documents via the application link/QR code on the notice.

Applications must be submitted on or before 5:00 PM, 25 September 2026. Shortlisted candidates will be intimated about the interview via email.

PI: Dr. Saikat Chakraborty | Co-PI: Dr. Ranabir Banik | Co-PI: Dr. Arnab Basu`,
    content: `Applications are invited for ONE post of CRS Project Fellow (Junior) - I / II under the CRS project "Probing the Low-Lying and Isomeric Structure of 128Cs: Insights into the (pi)h11/2 Orbital in the A ~ 130 Region", sanctioned by UGC-DAE Consortium for Scientific Research, India.

Essential Qualifications:
- CRS Project Fellow (Junior) - I: M.Sc. (not earlier than 3 years) with a minimum of 55% marks in Physics.
- CRS Project Fellow (Junior) - II: M.Sc. (not earlier than 3 years) with a minimum of 55% marks in Physics, with valid JEST / GATE / NET-JRF / Lectureship / UGC-CSIR-NET JRF / Lectureship.

Fellowship Amount:
- CRS Project Fellow (Junior) - I: Rs. 14,000/month + HRA
- CRS Project Fellow (Junior) - II: Rs. 31,000/month + HRA

Duration of the Project: 1 year (extendible up to 3 years).

Interested eligible candidates are invited to apply by submitting their complete CV, a recent passport-size photograph, and scanned copies of all relevant documents via the application link/QR code on the notice.

Applications must be submitted on or before 5:00 PM, 25 September 2026. Shortlisted candidates will be intimated about the interview via email.

PI: Dr. Saikat Chakraborty | Co-PI: Dr. Ranabir Banik | Co-PI: Dr. Arnab Basu`,
    date: '2026-09-03',
    documentUrl: '/crs-project-fellow-recruitment-2026.jpeg',
    applyUrl: 'https://forms.gle/sz894qRfb6NTGmKs7',
    isActive: true,
  },
];
